import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import '../styles/page-layout.css';

const ServiceUnavailablePage: React.FC = () => {
  const [timeLeft, setTimeLeft] = useState<string>('');

  useEffect(() => {
    // Beispiel für Countdown bis Service wieder verfügbar ist
    const targetTime = new Date();
    targetTime.setHours(targetTime.getHours() + 2); // 2 Stunden von jetzt

    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetTime.getTime() - now;

      if (distance > 0) {
        const hours = Math.floor(distance / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        setTimeLeft(`${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
      } else {
        setTimeLeft('Service sollte wieder verfügbar sein');
        clearInterval(timer);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <Layout
      title="Service nicht verfügbar | Stimm.DEV"
      description="Der Service ist vorübergehend nicht verfügbar. Wir arbeiten an Verbesserungen und sind bald wieder für Sie da."
      keywords="503, Service nicht verfügbar, Wartungsarbeiten"
    >
      <section className="wrapper">
        <div className="page-container" style={{ textAlign: 'center', padding: '4rem 2rem' }}>
          <div style={{ maxWidth: '600px', margin: '0 auto' }}>
            <h1 style={{ 
              fontSize: '6rem', 
              fontWeight: '800', 
              background: 'linear-gradient(135deg, #9b59b6, #8e44ad)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              marginBottom: '1rem'
            }}>
              503
            </h1>
            
            <h2 style={{ 
              fontSize: '2rem', 
              marginBottom: '1rem',
              color: 'var(--text-color)'
            }}>
              Service nicht verfügbar
            </h2>
            
            <p style={{ 
              fontSize: '1.1rem', 
              color: 'var(--text-muted)',
              marginBottom: '2rem',
              lineHeight: '1.6'
            }}>
              Der Service ist vorübergehend nicht verfügbar. Wir führen 
              geplante Wartungsarbeiten durch, um Ihnen ein besseres 
              Erlebnis zu bieten.
            </p>

            {timeLeft && (
              <div style={{
                padding: '1.5rem',
                background: 'var(--primary-color-light)',
                borderRadius: '1rem',
                marginBottom: '2rem',
                border: '2px solid var(--primary-color)'
              }}>
                <h3 style={{ marginBottom: '0.5rem', color: 'var(--text-color)' }}>
                  <i className="fas fa-clock" style={{ marginRight: '0.5rem' }}></i>
                  Geschätzte Wiederherstellung in:
                </h3>
                <div style={{
                  fontSize: '2rem',
                  fontWeight: 'bold',
                  fontFamily: 'monospace',
                  color: 'var(--primary-color)'
                }}>
                  {timeLeft}
                </div>
              </div>
            )}

            <div style={{ 
              display: 'flex', 
              gap: '1rem', 
              justifyContent: 'center',
              flexWrap: 'wrap',
              marginBottom: '3rem'
            }}>
              <button 
                onClick={handleRefresh}
                className="primary-button"
                style={{ 
                  border: 'none',
                  cursor: 'pointer',
                  background: 'var(--primary-color)',
                  color: 'white'
                }}
              >
                <i className="fas fa-sync-alt" style={{ marginRight: '0.5rem' }}></i>
                Status prüfen
              </button>
              
              <Link 
                to="/" 
                className="secondary-button"
                style={{ textDecoration: 'none' }}
              >
                <i className="fas fa-home" style={{ marginRight: '0.5rem' }}></i>
                Zur Startseite
              </Link>
            </div>

            <div style={{ 
              padding: '2rem',
              background: 'var(--card-background)',
              borderRadius: '1rem',
              border: '1px solid var(--border-color)',
              textAlign: 'left'
            }}>
              <h3 style={{ marginBottom: '1rem', color: 'var(--text-color)' }}>
                <i className="fas fa-tools" style={{ marginRight: '0.5rem', color: 'var(--info-color)' }}></i>
                Was passiert gerade?
              </h3>
              
              <ul style={{ 
                color: 'var(--text-muted)',
                lineHeight: '1.8',
                paddingLeft: '1.5rem'
              }}>
                <li>Server-Updates und Sicherheitspatches</li>
                <li>Datenbankoptimierungen für bessere Performance</li>
                <li>Neue Features werden implementiert</li>
                <li>Qualitätssicherung und Tests</li>
              </ul>

              <div style={{ 
                marginTop: '2rem',
                padding: '1rem',
                background: 'var(--success-color-light)',
                borderRadius: '0.5rem',
                borderLeft: '4px solid var(--success-color)'
              }}>
                <strong style={{ color: 'var(--text-color)' }}>
                  <i className="fas fa-heart" style={{ marginRight: '0.5rem' }}></i>
                  Vielen Dank für Ihr Verständnis!
                </strong>
                <p style={{ margin: '0.5rem 0 0 0', color: 'var(--text-muted)' }}>
                  Diese Wartungsarbeiten helfen uns, Ihnen einen noch besseren 
                  Service anzubieten. Bei Fragen erreichen Sie uns unter{' '}
                  <a 
                    href="mailto:support@stimm.dev" 
                    style={{ color: 'var(--primary-color)', textDecoration: 'none' }}
                  >
                    support@stimm.dev
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default ServiceUnavailablePage;
